/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react';
import {Row, Col, Box, Button, Pagination} from 'adminlte-2-react';
import Loader from '../utils/Loader';
import {Alert} from '../ui/alert';
import {
  getDate,
  getDateUtcOrEmpty,
  submitSearchOnEnterPress,
} from '../utils/utils';

import {ButtonWithLoading} from '../utils/ButtonWithLoading';
import {ModalConfirmarDesactivar} from './ModalConfirmarDesactivar';
import {ReferenciaObligatorios} from '../utils/etiquetaObligatorio/ReferenciaObligatorios';
import {SelectInput} from '../utils/SelectInput';
import {
  estadosDisabled,
  fechaMinimaPraReporteBusquedaYEstado,
  oportunidadEstadoDescById,
  oportunidadEstadoIds,
} from '../utils/constants';
import {ModalConfirmarReposicion} from './ModalConfirmarReposicion';
import {CustomDescriptionBlock} from '../ui/layout/CustomDescriptionBlock';
import {TextInput} from '../utils/TextInput';
import {CandidatosEnOportunidad} from './CandidatosEnOportunidad';
import {Content} from '../ui/Content';
import {ModalCambioEtapaV2} from './ModalCambioEtapaV2';
import {ModalNotasV2} from '../candidatos/ModalNotasV2';
import {alertTypes} from '../utils/Alert';
import config from './../config';
const queryString = require('query-string');

function EnviarMailInicio({oportunidad, enviarMailInicio, correoEnviado}) {
  if (oportunidad.correoInicioEnviadoTs) {
    return `Correo enviado el ${getDateUtcOrEmpty(
      oportunidad.correoInicioEnviadoTs,
    )}`;
  }

  if (correoEnviado) {
    return `Correo enviado el ${getDate()}`;
  }

  return (
    <ButtonWithLoading
      type="default"
      size="sm"
      text="Enviar mail"
      submit={() => enviarMailInicio(oportunidad)}
    />
  );
}

function getEtapas({candidato, etapasById}) {
  return (
    <div>
      <div style={{fontWeight: 'bold'}}>
        {etapasById?.[candidato?.etapasIds?.[0]]?.descripcion || 'N/A'}
      </div>
      {candidato.etapasIds.length > 1
        ? candidato.etapasIds.slice(1).map(etapaId => {
            return (
              <div className="text-muted">
                {etapasById[etapaId].descripcion}
              </div>
            );
          })
        : null}
    </div>
  );
}

function EditarOportunidadView({
  history,
  topAlert,
  submitAlert,
  totalResults,
  activePage,
  pageSize,
  handlePage,
  candidatos,
  modelGetCandidatosEnOport,
  oportunidadId,
  hideModalCambioEtapa,
  showModalCambioEtapa,
  etapasOptions,
  oportunidad,
  etapasById,
  oportunidadLoadStatus,
  selectedCandidato,
  setSelectedCandidato,
  isModalCambioEtapaShown,
  isModalConfirmarDesactivarShown,
  hideModalConfirmarDesactivar,
  showModalConfirmarDesactivar,
  desactivarCandidato,
  guardarEdicion,
  estadosOptions,
  estadoOption,
  setEstadoOption,
  modelGuardarEdicionOport,
  modelDesactivarCandidato,
  showModalConfirmarReposicion,
  hideModalConfirmarReposicion,
  isModalConfirmarReposicionShown,
  confirmarReposicion,
  modelGenerarReposicion,
  incluirCandidatos,
  setIncluirCandidatos,
  etapasEnOportunidad,
  conteoPorEtapa,
  descarteAlert,
  modelGetResumenEtapas,
  modelGetOportunidad,
  isModalNotasShown,
  hideModalNotas,
  showModalNotas,
  candidatoIdNumerico,
  setCandidatoIdNumerico,
  userIdNumerico,
  enviarMailInicio,
  modelEnviarMailInicio,
  correoTopAlert,
  correoEnviado,
  filtroNombre,
  setFiltroNombre,
  filtroEtapaOption,
  setFiltroEtapaOption,
  filtroEtapaOptions,
  filtroMotivoDescarteOption,
  setFiltroMotivoDescarteOption,
  filtroMotivoDescarteOptions,
  filtroOrigenPostulacionOption,
  filtroOrigenPostulacionOptions,
  setFiltroOrigenPostulacionOption,
  accion,
  setAccion,
  token,
  onAvanzarSuccess,
  onAvanzarError,
  usuarioOptions,
  usuariosCierre,
  setUsuariosCierre,
}) {
  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 1200;

  const descargarReporteBusqueda = () => {
    const params = queryString.stringify({
      userToken: token.raw,
      oportunidadId,
    });

    const baseUrl = config.api.baseUrl;

    const exportUrl = `${baseUrl}/v1/oportunidad/reporte/busqueda/excel?${params}`;

    window.open(exportUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <Content
      title={`Editar oportunidad ${oportunidad?.idNumerico || ''}`}
      history={history}>
      {topAlert.text && (
        <Alert
          title={topAlert.title}
          type={topAlert.type}
          text={topAlert.text}
          closable={topAlert.closable}
        />
      )}

      {oportunidad && selectedCandidato && accion && (
        <ModalCambioEtapaV2
          isModalCambioEtapaShown={isModalCambioEtapaShown}
          hideModalCambioEtapa={hideModalCambioEtapa}
          showModalCambioEtapa={showModalCambioEtapa}
          etapasOptions={etapasOptions}
          oportunidad={oportunidad}
          candidato={selectedCandidato}
          etapasById={etapasById}
          candidatoIdNumerico={candidatoIdNumerico}
          accion={accion}
          onSuccess={onAvanzarSuccess}
          onError={onAvanzarError}
          token={token}
          oportunidadId={oportunidadId}
        />
      )}

      {selectedCandidato && (
        <ModalConfirmarDesactivar
          isModalConfirmarDesactivarShown={isModalConfirmarDesactivarShown}
          hideModalConfirmarDesactivar={hideModalConfirmarDesactivar}
          showModalConfirmarDesactivar={showModalConfirmarDesactivar}
          selectedCandidato={selectedCandidato}
          etapasById={etapasById}
          desactivarCandidato={desactivarCandidato}
          isDesactivarButtonLoading={modelDesactivarCandidato.loading}
        />
      )}

      <ModalNotasV2
        isModalShown={isModalNotasShown}
        hideModal={hideModalNotas}
        showModal={showModalNotas}
        handlePage={handlePage}
        userIdNumerico={userIdNumerico}
        candidatoIdNumerico={candidatoIdNumerico}
        token={token}
        oportunidadId={oportunidadId}
      />

      <ModalConfirmarReposicion
        isModalConfirmarReposicionShown={isModalConfirmarReposicionShown}
        hideModalConfirmarReposicion={hideModalConfirmarReposicion}
        showModalConfirmarReposicion={showModalConfirmarReposicion}
        confirmarReposicion={confirmarReposicion}
        isConfirmarReposicionButtonLoading={modelGenerarReposicion.loading}
        incluirCandidatos={incluirCandidatos}
        setIncluirCandidatos={setIncluirCandidatos}
      />
      <Row>
        <Col md="10" mdOffset="1">
          <Loader isLoading={oportunidadId && !oportunidad}>
            <Row>
              <Col md="3">
                <Row>
                  <Box
                    title="Datos"
                    customOptions={
                      <div>
                        {oportunidad?.estado === oportunidadEstadoIds.f && (
                          <Button
                            size="sm"
                            margin
                            type="default"
                            text="Reposición"
                            onClick={showModalConfirmarReposicion}
                          />
                        )}
                        <Button
                          size="sm"
                          type="default"
                          margin
                          text="Editar detalles"
                          onClick={() =>
                            history.push(
                              `/editarDetalleOportunidad/${oportunidadId}`,
                            )
                          }
                        />
                      </div>
                    }>
                    <ReferenciaObligatorios />
                    {estadoOption?.value === 'f' && (
                      <Alert
                        title={'Condiciones de cierre'}
                        type={alertTypes.warning}
                        text={
                          'El cierre de la oportunidad contará para los usuarios seleccionados'
                        }
                        closable={false}
                      />
                    )}
                    <SelectInput
                      label="Estado"
                      value={estadoOption}
                      options={estadosOptions}
                      setValue={setEstadoOption}
                      disabled={
                        oportunidad?.estado === 'f' &&
                        token?.decoded?.rol !== 'admin'
                      }
                      required
                    />

                    {estadoOption?.value === 'f' && (
                      <SelectInput
                        label="Usuarios cierre"
                        value={usuariosCierre}
                        options={usuarioOptions}
                        setValue={setUsuariosCierre}
                        isMulti
                        required
                        disabled={
                          oportunidad?.estado === 'f' &&
                          token?.decoded?.rol !== 'admin'
                        }
                      />
                    )}

                    <ButtonWithLoading
                      text="Guardar"
                      disabled={estadoOption?.value === oportunidad?.estado}
                      submit={guardarEdicion}
                      loading={modelGuardarEdicionOport.loading}
                    />
                  </Box>
                </Row>
                <Row>
                  <Box title="Correo de inicio de oportunidad">
                    {correoTopAlert.text && (
                      <Alert
                        title={correoTopAlert.title}
                        type={correoTopAlert.type}
                        text={correoTopAlert.text}
                        closable={correoTopAlert.closable}
                      />
                    )}

                    <Loader
                      isLoading={!oportunidad || modelEnviarMailInicio.loading}>
                      <EnviarMailInicio
                        oportunidad={oportunidad}
                        modelEnviarMailInicio={modelEnviarMailInicio}
                        enviarMailInicio={enviarMailInicio}
                        correoEnviado={correoEnviado}
                      />
                    </Loader>
                  </Box>
                </Row>
              </Col>
              <Col md="9">
                <Loader
                  isLoading={
                    modelGetResumenEtapas.loading || modelGetOportunidad.loading
                  }>
                  {!!etapasEnOportunidad && etapasById && (
                    <Box
                      title="Candidatos por etapa"
                      customOptions={
                        new Date(oportunidad.creacionTs) >
                        new Date(fechaMinimaPraReporteBusquedaYEstado) ? (
                          <div>
                            <Button
                              size="sm"
                              type="default"
                              margin
                              text="Reporte de busqueda"
                              onClick={descargarReporteBusqueda}
                            />
                          </div>
                        ) : null
                      }>
                      <div
                        style={{
                          maxHeight: 255,
                          minHeight: 255,
                          overflowY: 'scroll',
                        }}>
                        <Row>
                          {etapasEnOportunidad.map(etapaIdNumerico => {
                            return (
                              <Col md="4">
                                <CustomDescriptionBlock
                                  text={
                                    etapasById[etapaIdNumerico]?.descripcion
                                  }
                                  header={conteoPorEtapa[etapaIdNumerico]}
                                />
                              </Col>
                            );
                          })}
                        </Row>
                      </div>
                    </Box>
                  )}
                </Loader>
              </Col>
            </Row>
            <Row>
              <Box title="Candidatos incluidos">
                <Col md="12">
                  {estadosDisabled.includes(oportunidad?.estado) && (
                    <Alert
                      title={'Restriccion de avance'}
                      type={'warning'}
                      text={`No es posible avanzar de etapa cuando la oportunidad esta en estado ${
                        oportunidadEstadoDescById[oportunidad?.estado]
                      }`}
                      closable={false}
                    />
                  )}

                  <Row>
                    {descarteAlert.text && (
                      <Alert
                        title={descarteAlert.title}
                        type={descarteAlert.type}
                        text={descarteAlert.text}
                        closable={descarteAlert.closable}
                      />
                    )}

                    <h4>Filtros</h4>
                    <Col md="3">
                      <TextInput
                        label="Nombre"
                        placeholder="Nombre"
                        initialValue={filtroNombre}
                        setValue={setFiltroNombre}
                        onKeyDown={event =>
                          submitSearchOnEnterPress(event, () => handlePage(0))
                        }
                      />
                    </Col>
                    <Col md="3">
                      <SelectInput
                        label="Etapa"
                        value={filtroEtapaOption}
                        options={filtroEtapaOptions}
                        setValue={setFiltroEtapaOption}
                      />
                    </Col>
                    <Col md="3">
                      <SelectInput
                        label="Motivo de descarte"
                        value={filtroMotivoDescarteOption}
                        options={filtroMotivoDescarteOptions}
                        setValue={setFiltroMotivoDescarteOption}
                      />
                    </Col>
                    <Col md="3">
                      <SelectInput
                        label="Origen de postulación"
                        value={filtroOrigenPostulacionOption}
                        options={filtroOrigenPostulacionOptions}
                        setValue={setFiltroOrigenPostulacionOption}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div style={{marginRight: 30}}>
                        <ButtonWithLoading
                          pullRight
                          text="Buscar"
                          submit={() => handlePage(0)}
                          isLoading={modelGetCandidatosEnOport.loading}
                        />
                      </div>
                    </Col>
                  </Row>

                  <hr />

                  <h4>Lista</h4>

                  <div style={{display: 'block'}}>
                    <span>Total: {totalResults}</span>
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      flexDirection: isMobile ? 'column' : 'row',
                      justifyContent: 'space-between',
                    }}>
                    <div>
                      <Pagination
                        activePage={activePage}
                        pageSize={pageSize}
                        totalElements={totalResults}
                        onChange={handlePage}
                        labels={{
                          first: 'Primera',
                          last: 'Última',
                          previous: 'Anterior',
                          next: 'Siguiente',
                        }}
                      />
                    </div>
                  </div>

                  <CandidatosEnOportunidad
                    modelGetCandidatosEnOport={modelGetCandidatosEnOport}
                    candidatos={candidatos}
                    getEtapas={getEtapas}
                    etapasById={etapasById}
                    oportunidadId={oportunidadId}
                    setCandidatoIdNumerico={setCandidatoIdNumerico}
                    setSelectedCandidato={setSelectedCandidato}
                    setAccion={setAccion}
                    showModalCambioEtapa={showModalCambioEtapa}
                    showModalConfirmarDesactivar={showModalConfirmarDesactivar}
                    oportunidadLoadStatus={oportunidadLoadStatus}
                    showModalNotas={showModalNotas}
                    oportunidad={oportunidad}
                  />

                  <Pagination
                    activePage={activePage}
                    pageSize={pageSize}
                    totalElements={totalResults}
                    onChange={handlePage}
                    labels={{
                      first: 'Primera',
                      last: 'Última',
                      previous: 'Anterior',
                      next: 'Siguiente',
                    }}
                  />
                  <div>
                    <span>Total: {totalResults}</span>
                  </div>

                  {submitAlert.text && (
                    <Alert
                      title={submitAlert.title}
                      type={submitAlert.type}
                      text={submitAlert.text}
                      closable={submitAlert.closable}
                    />
                  )}
                </Col>
              </Box>
            </Row>
          </Loader>
        </Col>
      </Row>
    </Content>
  );
}

export {EditarOportunidadView};
